import React from "react";
import ClassificacaoPage from "./ClassificacaoPage";

const ClassificacaoPageView = () => <ClassificacaoPage admin={false} />;

export default ClassificacaoPageView;
